import styled from "styled-components";
import {Flex} from "../../../assets/ui";

export const StyledSectionWrapper = styled(Flex)`
  flex-direction: column;
  padding: 0 24px 12px;
  border-bottom: 1px solid rgba(58, 79, 106, 0.2);

  & img {
    width: 100%;
    box-shadow: 0px 24px 46px rgba(0, 0, 0, 0.199574);
  }
  
  & h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 24px;
    color: #233247;
  }
  
  & p {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 20px;
    color: #586981;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    flex-direction: row;
    padding-top: 68px;
    padding-bottom: 60px;
    
    & img {
      max-width: 420px;
    }
  }

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    padding-left: 80px;
    padding-right: 80px;
    max-width: 1280px;
    margin: 0 auto;
  }
`;
